import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["stepKind", "stepSource", "sourceTitle", "buildLink", "uploadLink"]
  static values = { newPath: { type: String, default: "/practitioners/documents/new" } }

  pickKind(event) {
    const kind = event.currentTarget.dataset.kind
    this._selectedKind = kind

    // Update title
    const kindLabel = kind.charAt(0).toUpperCase() + kind.slice(1)
    if (this.hasSourceTitleTarget) {
      this.sourceTitleTarget.textContent = `How do you want to create this ${kindLabel}?`
    }

    // Build URLs
    const buildUrl = `${this.newPathValue}?kind=${encodeURIComponent(kind)}&source=built`
    const uploadUrl = `${this.newPathValue}?kind=${encodeURIComponent(kind)}&source=uploaded`

    if (this.hasBuildLinkTarget) this.buildLinkTarget.href = buildUrl
    if (this.hasUploadLinkTarget) this.uploadLinkTarget.href = uploadUrl

    // Switch steps
    this.stepKindTarget.classList.add("hidden")
    this.stepSourceTarget.classList.remove("hidden")
  }

  backToKind() {
    this.stepSourceTarget.classList.add("hidden")
    this.stepKindTarget.classList.remove("hidden")
  }
}
